import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { logEvent } from '../../utils/logEvent';
import { FaChevronLeft } from 'react-icons/fa';

import { BoldText, RegularText } from '../../components/common/Text';
import StyledTappable from '../../components/common/StyledTappable';
import ManipalLogo from '../../images/ManipalLogo.png';
import VisitLogo from '../../images/visitlogo.svg';
import HospitalService from '../../images/HospitalService.svg';
import EnterAppointmentDetails from '../../images/AppointmentDetails.svg';
import RecieveCashlessLetter from '../../images/RecieveCashlessLetter.svg';
import CompleteAppointment from '../../images/CompleteAppointment.svg';
import Pharmcy from '../../images/Pharmacy.png';
import ClinicAppointments from '../../images/ClinicAppointments.png';
import LabTests from '../../images/LabTests.png';
import { fetchCenterLogos } from '../../services/scanAndPay';
import { getLabHomePageData } from '../lab-test/v2/services';
import RequestCard from '../lab-test/v2/components/Cards/RequestCard';
import PaginationDots from '../lab-test/v2/components/PaginationDots';
import { useActiveCarouselIndex } from '../lab-test/v2/hooks/useActiveCarouselIndex';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  width: 100%;
  max-width: 100vw;
  background: #f7f4ed;
  overflow-y: auto;
  overflow-x: hidden;
`;

const Header = styled.div`
  position: relative;
  background: linear-gradient(
    180deg,
    #fadfba -40.53%,
    #361797 7.39%,
    #391c94 48.16%,
    #2e1285 77.63%
  );
  border-radius: 0 0 40px 40px;
  padding: 40px 16px 24px;
  overflow: hidden;
  width: 100%;
  flex-shrink: 0;

  @media (min-width: 768px) {
    padding: 48px 24px 28px;
  }

  /* Purple shadow top right */
  &::before {
    content: '';
    position: absolute;
    top: -100px;
    right: -100px;
    width: 300px;
    height: 300px;
    background: radial-gradient(
      circle,
      rgba(138, 43, 226, 0.4) 0%,
      rgba(138, 43, 226, 0) 70%
    );
    border-radius: 50%;
  }

  /* Greenish shadow bottom left */
  &::after {
    content: '';
    position: absolute;
    bottom: -80px;
    left: -80px;
    width: 250px;
    height: 250px;
    background: radial-gradient(
      circle,
      rgba(0, 255, 200, 0.3) 0%,
      rgba(0, 255, 200, 0) 70%
    );
    border-radius: 50%;
  }
`;
const HeaderContent = styled.div`
  text-align: center;
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const LogoContainer = styled.div`
  display: flex;
  width: 250px;
  height: 52px;
  padding: 6px 14px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 12px;
  border-radius: 40px;
  background: #fff;
  margin: 0 auto 12px auto;

  @media (min-width: 768px) {
    width: 250px;
    height: 52px;
  }
`;

const LogoImage = styled.img`
  height: 28px;
  max-width: 100%;
  width: auto;
  object-fit: contain;
  transform: translate3d(0, 0, 0);
  -webkit-transform: translate3d(0, 0, 0);
  backface-visibility: hidden;
  -webkit-backface-visibility: hidden;
  -webkit-font-smoothing: subpixel-antialiased;
  image-rendering: -webkit-optimize-contrast;
  image-rendering: optimize-contrast;

  @media (min-width: 768px) {
    height: 32px;
  }
`;

const WelcomeText = styled.div`
  color: #fff;
  font-feature-settings:
    'liga' off,
    'clig' off;
  font-family: 'Bricolage Grotesque';
  font-size: 31px;
  font-style: normal;
  font-weight: 800;
  line-height: 107%;
  margin: 0;
  margin-bottom: 12px;

  @media (min-width: 768px) {
    font-size: 31px;
  }
`;

const SubTitle = styled.div`
  font-size: 13px;
  margin: 0;
  font-style: italic;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  flex-wrap: wrap;

  .cashless {
    color: #fadfba;
    font-family: Inter;
    font-size: 16px;
    font-style: italic;
    font-weight: 900;
    line-height: 150%;
  }

  .powered-by {
    color: #fff;
    font-family: Inter;
    font-size: 16px;
    font-style: italic;
    font-weight: 500;
    line-height: 150%;
  }

  @media (min-width: 768px) {
    font-size: 14px;
  }
`;

const VisitLogoImage = styled.img`
  width: 59.191px;
  height: 19.379px;
  object-fit: contain;
  filter: brightness(0) invert(1);
  transform: translate3d(0, 0, 0);
  -webkit-transform: translate3d(0, 0, 0);
  backface-visibility: hidden;
  -webkit-backface-visibility: hidden;
  -webkit-font-smoothing: subpixel-antialiased;
  image-rendering: -webkit-optimize-contrast;
  image-rendering: optimize-contrast;
`;

const ContentSection = styled.div`
  margin-top: 16px;
  padding: 12px 0;
`;
const ContainerSection = styled.div`
  padding: 12px 16px 80px 16px;
  background: #f7f4ed;

  @media (min-width: 768px) {
    padding: 24px 24px 80px 24px;
    max-width: 768px;
    margin: 0 auto;
    width: 100%;
  }

  @media (min-width: 1024px) {
    max-width: 900px;
  }
`;
const SectionTitle = styled.div`
  font-family: Inter;
  font-weight: 600;
  font-size: 16px;
  letter-spacing: 0.5px;
  vertical-align: middle;
  margin-bottom: 12px;
`;

const ServiceCardsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  margin-bottom: 24px;

  @media (min-width: 768px) {
    gap: 14px;
    margin-bottom: 28px;
  }
`;

const ServiceCard = styled.div`
  background: transparent;
  border-radius: 0;
  padding: 0;
  display: block;
  border: none;
  cursor: pointer;
  grid-column: ${(props) => (props.isRectangular ? 'span 2' : 'span 1')};
  overflow: visible;
  user-select: none;
  -webkit-tap-highlight-color: transparent;

  img {
    width: 100%;
    height: auto;
    display: block;
    border-radius: 0;
    transform: translate3d(0, 0, 0);
    -webkit-transform: translate3d(0, 0, 0);
    backface-visibility: hidden;
    -webkit-backface-visibility: hidden;
    -webkit-font-smoothing: subpixel-antialiased;
    image-rendering: -webkit-optimize-contrast;
    image-rendering: optimize-contrast;
    pointer-events: none;
  }

  &:active {
    opacity: 0.8;
  }
`;

const ServiceImageContainer = styled.div`
  width: ${(props) => (props.isRectangular ? '100px' : '100px')};
  height: ${(props) => (props.isRectangular ? '80px' : '80px')};
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  position: ${(props) => (props.isRectangular ? 'relative' : 'absolute')};
  bottom: ${(props) => (props.isRectangular ? 'auto' : '0')};
  right: ${(props) => (props.isRectangular ? 'auto' : '0')};
  margin: 0;

  @media (min-width: 768px) {
    width: ${(props) => (props.isRectangular ? '80px' : '85px')};
    height: ${(props) => (props.isRectangular ? '80px' : '85px')};
    bottom: ${(props) => (props.isRectangular ? 'auto' : '0')};
    right: ${(props) => (props.isRectangular ? 'auto' : '0')};
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

const ServiceContent = styled.div`
  flex: ${(props) => (props.isRectangular ? 'none' : '1')};
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  z-index: 1;
  max-width: ${(props) => (props.isRectangular ? 'calc(100% - 90px)' : '100%')};
  ${'' /* padding-right: ${props => props.isRectangular ? '0' : '85px'}; */}

  @media (min-width: 768px) {
    ${'' /* padding-right: ${props => props.isRectangular ? '0' : '95px'}; */}
  }
`;

const ServiceName = styled.div`
  color: #0f0b28;
  font-size: 14px;
  font-weight: 600;
  margin: 0 0 6px 0;
  line-height: 1.3;
  letter-spacing: -0.14px;
  white-space: nowrap;

  @media (min-width: 768px) {
    font-size: 14px;
  }
`;

const ServiceDescription = styled.div`
  color: #9ca3af;
  font-size: 13px;
  margin: 0;
  line-height: 1.5;
  font-weight: 400;
  white-space: normal;

  @media (min-width: 768px) {
    font-size: 14px;
  }
`;

const RequestsSection = styled.section`
  padding: 12px 0;
`;

const RequestsSectionTitle = styled.p`
  color: #0f0b2b;
  font-weight: 600;
  font-size: 16px;
  margin: 0;
  font-family: Inter;
  font-weight: 600;
  font-style: Semi Bold;
  font-size: 16px;
  leading-trim: NONE;
  line-height: 150%;
  letter-spacing: 0.5px;
  vertical-align: middle;
  margin-left: 16px;
`;

const RequestsScrollViewport = styled.div`
  display: flex;
  gap: 12px;
  padding: 12px 0;
  overflow-x: scroll;
  scroll-behavior: smooth;
  scrollbar-width: none;
  -ms-overflow-style: none;

  & > * {
    &:first-child {
      margin-left: 16px;
    }

    &:last-child {
      margin-right: 16px;
    }
  }

  &::-webkit-scrollbar {
    display: none;
  }
`;

const HowItWorksSection = styled.div``;

const HowItWorksTitle = styled.div`
  font-family: Inter;
  font-weight: 600;
  font-size: 16px;
  vertical-align: middle;
  margin-bottom: 12px;
`;

const StepsImage = styled.img`
  width: 100%;
  display: block;
  border-radius: 16px;
`;

const StepsContainer = styled.div`
  background: white;
  border-radius: 16px;
  padding: 20px 16px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.06);
  border: none;

  @media (min-width: 768px) {
    padding: 24px 20px;
  }
`;

const StepItem = styled.div`
  display: flex;
  align-items: flex-start;
  margin-bottom: 0;
  position: relative;
`;

const StepSeparator = styled.div`
  height: 1px;
  background: #e5e7eb;
  margin: 20px 0 20px 40px;
  width: calc(100% - 40px);
`;

const StepItem1 = styled(StepItem)`
  &::before {
    content: '';
    position: absolute;
    left: 9px;
    top: 28px;
    width: 2px;
    height: calc(100% - 28px);
    background: #e5e7eb;
    z-index: 0;
  }
`;

const StepItem2 = styled(StepItem)`
  &::before {
    content: '';
    position: absolute;
    left: 9px;
    top: 24px;
    width: 2px;
    height: calc(100% - 24px);
    background: #e5e7eb;
    z-index: 0;
  }
`;

const StepItem3 = styled(StepItem)`
  &::before {
    content: '';
    position: absolute;
    left: 9px;
    top: 24px;
    width: 2px;
    height: calc(100% - 24px);
    background: #e5e7eb;
    z-index: 0;
  }
`;

const StepItem4 = styled(StepItem)``;

const StepNumber1 = styled.div`
  width: 20px;
  height: 20px;
  background: #6b46c1;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 12px;
  flex-shrink: 0;
  margin-right: 12px;
  z-index: 1;
`;

const StepNumber2 = styled.div`
  color: #6b46c1;
  font-weight: 700;
  font-size: 12px;
  flex-shrink: 0;
  margin-right: 12px;
  z-index: 1;
  width: 20px;
  text-align: center;
`;

const StepNumber3 = styled(StepNumber2)``;
const StepNumber4 = styled(StepNumber2)``;

const StepIconContainer = styled.div`
  width: 62px;
  height: 62px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
  flex-shrink: 0;

  @media (min-width: 768px) {
    width: 62px;
    height: 62px;
    margin-right: 14px;
  }

  img {
    width: 62px;
    height: 62px;
    object-fit: contain;
    transform: translate3d(0, 0, 0);
    -webkit-transform: translate3d(0, 0, 0);
    backface-visibility: hidden;
    -webkit-backface-visibility: hidden;
    -webkit-font-smoothing: subpixel-antialiased;
    image-rendering: -webkit-optimize-contrast;
    image-rendering: optimize-contrast;

    @media (min-width: 768px) {
      width: 62px;
      height: 62px;
    }
  }
`;

const StepContent = styled.div`
  flex: 1;
  padding-top: 10px;
`;

const StepTitle = styled.div`
  color: #111827;
  font-size: 15px;
  margin: 0;
  line-height: 1.5;
  font-weight: 600;

  @media (min-width: 768px) {
    font-size: 16px;
  }
`;

const getPlatform = () => {
  const ua = navigator.userAgent;
  if (/android/i.test(ua)) return 'android';
  if (/iphone|ipad|ipod/i.test(ua)) return 'ios';
  return 'web';
};
const ScanAndPayHomepage = (props) => {
  const [hospitalLogo, setHospitalLogo] = useState(null);
  const [hospitalId, setHospitalId] = useState(null);
  const [hexCode, setHexCode] = useState(null);
  const [centerName, setCenterName] = useState(null);
  const [scanAndPayMeta, setScanAndPayMeta] = useState({});
  const [loading, setLoading] = useState(true);
  const [cards, setCards] = useState([]);
  const [cardsLoaded, setCardsLoaded] = useState(false);

  const { containerRef, setItemRef, activeIndex } = useActiveCarouselIndex(
    cards.length
  );

  const scrollStopTimerRef = useRef(null);
  const lastStoppedIndexRef = useRef(null);
  const cardsInitialisedRef = useRef(false);

  useEffect(() => {
    if (typeof activeIndex !== 'number' || cards.length === 0) return;

    // Skip programmatic index changes on initial data load / scroll restoration
    if (!cardsInitialisedRef.current) {
      cardsInitialisedRef.current = true;
      lastStoppedIndexRef.current = activeIndex;
      return;
    }

    if (scrollStopTimerRef.current) clearTimeout(scrollStopTimerRef.current);
    scrollStopTimerRef.current = setTimeout(() => {
      if (lastStoppedIndexRef.current !== activeIndex) {
        lastStoppedIndexRef.current = activeIndex;
        logEvent("Scan QR Your Request's card scrolled", {
          noOfCardsScrolled: activeIndex + 1,
          noOfCardsPresent: cards.length,
        });
      }
    }, 300);
    return () => clearTimeout(scrollStopTimerRef.current);
  }, [activeIndex, cards.length]);

  useEffect(() => {
    const { authToken, loginState } = props;
    if (loginState === 'LOGGED_IN' && authToken) {
      getLabHomePageData(authToken, 0, 0)
        .then((res) => setCards(res?.cards || []))
        .catch(() => {})
        .finally(() => setCardsLoaded(true));
    } else {
      setCardsLoaded(true);
    }
  }, [props.loginState, props.authToken]);

  useEffect(() => {
    if (loading || !cardsLoaded) return;
    logEvent('Hospital QR Code Home', {
      qrId: hexCode,
      partnerId: scanAndPayMeta.partnerId,
      centerId: scanAndPayMeta.partnerCenterId,
      centerName,
      platform: getPlatform(),
      isLoggedIn: props.loginState === 'LOGGED_IN',
      entrySource: 'scan_and_pay',
      activeRequestsCount: cards.length,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading, cardsLoaded]);
  console.log("cards===23=3=13=21=3=21=321=3=1=32==321=",cards)
  useEffect(() => {
    const { location } = props;
    const params = new URLSearchParams(location.search);
    const hexCodeParam = params.get('hexCode') || '';
    if (hexCodeParam) {
      setHexCode(hexCodeParam);
    }

    fetchCenterLogos(hexCodeParam)
      .then((res) => {
        if (res && res.logos) {
          setHospitalLogo(res.logos.hospitalLogo || '');
          if (res.centerId) {
            setHospitalId(res.centerId);
          }
          setCenterName(res?.centerName || null);
          setScanAndPayMeta({
            partnerId: res?.labPartnerId,
            partnerCenterId: res?.labCenterId,
            addressId: res?.addressId,
          });
          setLoading(false);
        }
      })
      .catch((err) => {
        console.error('Error fetching center logos:', err);
        setLoading(false);
      });
  }, []);

  const handleBackPress = () => {
    const { history } = props;
    history.goBack();
  };

  const handleServiceClick = (serviceName) => {
    const { history, loginState, authToken, landingPageData } = props;

    const serviceLabel = serviceName === 'lab-tests' ? 'Labs' : 'Offline';
    logEvent('Hospital QR Code Service Click', {
      service: serviceLabel,
      qrId: hexCode,
      partnerId: scanAndPayMeta.partnerId,
      centerId: scanAndPayMeta.partnerCenterId,
      centerName,
      platform: getPlatform(),
      entrySource: 'scan_and_pay',
    });

    if (serviceName === 'lab-tests') {
      if (loginState === 'LOGGED_IN' && authToken) {
        history.push({
          pathname: '/lab-test',
          search: '?uploadPrescription=true&isScanAndPay=1',
          state: {
            isSelfBookScanAndPay: '1',
            hexCode,
            isFromScanAndPay: true,
            hospitalLogo,
            ...scanAndPayMeta,
          },
        });
      } else {
        let redirectUrl = '/login?rt=redirect?rt=scan-and-pay-labs';
        if (hexCode) {
          redirectUrl += `%26hexCode=${hexCode}`;
        }
        if (scanAndPayMeta.partnerId) {
          redirectUrl += `%26partnerId=${scanAndPayMeta.partnerId}`;
        }
        if (scanAndPayMeta.partnerCenterId) {
          redirectUrl += `%26partnerCenterId=${scanAndPayMeta.partnerCenterId}`;
        }
        if (hospitalLogo) {
          redirectUrl += `%26hospitalLogo=${encodeURIComponent(hospitalLogo)}`;
        }
        history.push(redirectUrl);
      }
      return;
    }

    // Default: consultation
    const headerCard = landingPageData?.headerCard;
    const hospitalName = headerCard?.header || null;
    const logoToUse = headerCard?.hospitalLogo || hospitalLogo;

    if (loginState === 'LOGGED_IN' && authToken) {
      history.push('/consultation/start', {
        card: 'pre-book-appointment',
        showOnlineAndOffline: false,
        isFromScanAndPay: true,
        hospitalId: hospitalId,
        hospitalName: hospitalName,
        hospitalLogo: logoToUse,
        hexCode: hexCode,
        isSelfBookScanAndPay: '1',
      });
    } else {
      let redirectUrl = '/login?rt=redirect?rt=offline-self-book';
      if (hospitalId) {
        redirectUrl += `%26hospitalId=${hospitalId}`;
      }
      if (hexCode) {
        redirectUrl += `%26hexCode=${hexCode}`;
      }
      history.push(redirectUrl);
    }
  };

  const services = [
    {
      image: ClinicAppointments,
      name: 'Clinic Appointments',
      description: 'Book Consultation with Doctor',
      key: 'consultation',
    },
    {
      image: LabTests,
      name: 'Lab Tests',
      description: 'Book Lab Tests & Diagnostics',
      key: 'lab-tests',
    },
    // {
    //   image: Pharmcy,
    //   name: 'Pharmacy',
    //   description: 'Get your prescribed medicines',
    //   key: 'pharmacy'
    // },
  ];

  const handleRequestCardClick = ({
    cardType,
    digitisationId,
    orderId,
    cartId,
    uploadedOn,
    collectionDate,
    slot,
  }) => {
    const { history } = props;

    if (
      cardType === 'digitisationPending' ||
      cardType === 'availableCart' ||
      cardType === 'cashlessLetterGenerated'
    ) {
      const slotDisplayText =
        collectionDate || slot
          ? [collectionDate, slot].filter(Boolean).join(', ')
          : uploadedOn;

      history.push('/lab-test/order', {
        digitisationId,
        cartId,
        hexCode,
        hospitalLogo,
        slotDisplayText,
        partnerId: scanAndPayMeta.partnerId,
        partnerCenterId: scanAndPayMeta.partnerCenterId,
      });
    } else {
      history.push('/lab-test/order-status', {
        orderId,
        digitisationId,
        cartId,
      });
    }
  };

  const steps = [
    { image: HospitalService, title: 'Select a service' },
    { image: EnterAppointmentDetails, title: 'Enter your appointment details' },
    {
      image: RecieveCashlessLetter,
      title: 'Receive your instant cashless letter',
    },
    {
      image: CompleteAppointment,
      title: 'Complete your appointment cash free!',
    },
  ];
  return (
    <Container>
      <Header>
        <HeaderContent>
          <WelcomeText>Welcome to</WelcomeText>
          {hospitalLogo && (
            <LogoContainer>
              <LogoImage src={hospitalLogo} alt={'Hospital Logo'} />
            </LogoContainer>
          )}
          <SubTitle>
            <span className="cashless">Cashless</span>
            <span className="powered-by">Powered by</span>
            <VisitLogoImage src={VisitLogo} alt="VISIT" />
          </SubTitle>
        </HeaderContent>
      </Header>

      {/* Request Cards   */}
      {cards?.length > 0 && (
        <ContentSection>
          <RequestsSectionTitle>Ongoing Requests</RequestsSectionTitle>
          {/* Your Request’s card scrolled  event ✅ */}

          <RequestsScrollViewport ref={containerRef}>
            {cards?.map((card, idx) => (
              <RequestCard
                key={card.digitisationId ?? idx}
                {...card}
                ref={setItemRef(idx)}
                index={idx}
                onTestClick={() => {}}
                onCardClick={handleRequestCardClick}
                isScanNpay
                isScanAndPayFlow
                scanAndPayQrId={hexCode}
                scanAndPayPartnerId={scanAndPayMeta.partnerId}
                scanAndPayCenterId={scanAndPayMeta.partnerCenterId}
              />
            ))}
          </RequestsScrollViewport>

          <PaginationDots
            count={cards?.length || 0}
            activeIndex={activeIndex}
          />
        </ContentSection>
      )}

      <ContainerSection>
        <SectionTitle>Our Services</SectionTitle>

        <ServiceCardsContainer>
          {services.map((service) => (
            <ServiceCard
              key={service.key}
              onClick={() => handleServiceClick(service.key)}
              isRectangular={service.key === 'pharmacy'}
            >
              <img src={service.image} alt={service.name} />
            </ServiceCard>
          ))}
        </ServiceCardsContainer>

        <HowItWorksSection>
          <HowItWorksTitle>How it Works</HowItWorksTitle>

          <StepsContainer>
            <StepItem1>
              <StepNumber1>1</StepNumber1>
              <StepIconContainer>
                <img src={HospitalService} alt="Select a service" />
              </StepIconContainer>
              <StepContent>
                <StepTitle>Select a service</StepTitle>
              </StepContent>
            </StepItem1>

            <StepSeparator />

            <StepItem2>
              <StepNumber2>2</StepNumber2>
              <StepIconContainer>
                <img
                  src={EnterAppointmentDetails}
                  alt="Enter your appointment details"
                />
              </StepIconContainer>
              <StepContent>
                <StepTitle>Enter your appointment details</StepTitle>
              </StepContent>
            </StepItem2>

            <StepSeparator />

            <StepItem3>
              <StepNumber3>3</StepNumber3>
              <StepIconContainer>
                <img
                  src={RecieveCashlessLetter}
                  alt="Receive your instant cashless letter"
                />
              </StepIconContainer>
              <StepContent>
                <StepTitle>Receive your instant cashless letter</StepTitle>
              </StepContent>
            </StepItem3>

            <StepSeparator />

            <StepItem4>
              <StepNumber4>4</StepNumber4>
              <StepIconContainer>
                <img
                  src={CompleteAppointment}
                  alt="Complete your appointment cash free!"
                />
              </StepIconContainer>
              <StepContent>
                <StepTitle>Complete your appointment cash free!</StepTitle>
              </StepContent>
            </StepItem4>
          </StepsContainer>
        </HowItWorksSection>
      </ContainerSection>
    </Container>
  );
};

const mapStateToProps = (state) => ({
  authToken: state.user.authToken,
  loginState: state.app.loginState,
});

export default connect(mapStateToProps)(ScanAndPayHomepage);
